import React from "react";
import PaymentAgreementContextProvider, {
    PaymentAgreementContext,
    ACTIONS,
} from "../../context/PaymentAgreementContextProvider";
import { getPageLayoutType, decode_utf8 } from "../../../../common/utils/utilsFunc";
import AlertModal from "../../../../common/components/AlertModal";
import PrivPa from "../PrivPa";
import PubPa from "../PubPa";
import SecondStep from "../SecondStep";
import { useModal } from "@clayui/modal";
import Loading from "../../../../common/components/Loading";
import HeaderSearch from "../../../../common/components/HeaderSearch";
import { CGE } from "../../../../common/components/CGE";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from "../../../../common/hooks/useCookie";

const PREOFFER_TEXT =
    "Estimado cliente, hemos dispuesto facilidades a través de un convenio especial, con un pie flexible y hasta 6 cuotas sin intereses, ni reajustes. ¿Desea revisar este convenio especial?";

const ControllerPaymentAgreement = ({ properties }) => {
    const [state, dispatch] = React.useContext(PaymentAgreementContext);
    const [inputSearch, setInputSearch] = React.useState("");
    const [inputSelected, setInputSelected] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [msgModalAlert, setMsgModalAlert] = React.useState(false);
    const [visibleModal, setVisibleModal] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
            setTypeModal(false);
        },
    });

    // Modal pre-oferta
    const { observer: preOfferObserver, onClose: preOfferOnClose } = useModal({
        onClose: () => setShowPreOffer(false),
    });

    const handleCloseAndRedirect = () => {
        setVisibleModal(false);
        window.location.href = getPageLayoutType()
            ? `/group/guest/convenio-de-pago`
            : "/convenio-de-pago";
    };

    const [typeModal, setTypeModal] = React.useState(false);
    const [sucessAlert, setSucessAlert] = React.useState(false);
    const [redirectAlert, setRedirectAlert] = React.useState(false);
    const [buttonGenerarConvenio, setButtonGenerarConvenio] = React.useState(false);
    const [nextStepPag, setNextStepPag] = React.useState(false);
    let data = state.idList ? state.idList : [];
    const [dues, setDues] = React.useState("");
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [responseVc, setResponseVc] = React.useState({});
    const [responseVcAux, setResponseVcAux] = React.useState({});
    const [responseSc, setResponseSc] = React.useState({});
    const [canalFetch, setCanalFetch] = React.useState("");
    const [selectedFile, setSelectedFile] = React.useState({});
    const [idClient, setIdClient] = React.useState("");
    const [detailClientJson, setDetailClientJson] = React.useState([]);
    const [inputFileValidate, setInputFileValidate] = React.useState(false);
    const [disabledBtn, setDisabledBtn] = React.useState(false);
    const [isClientIdCaptchaChecked, setIsClientIdCaptchaChecked] = React.useState(false);
    const [showWebContentPa, setShowWebContentPa] = React.useState(false);
    const [webContentHtmlPa, setWebContentHtmlPa] = React.useState("");
    const [showWebContentPf, setShowWebContentPf] = React.useState(false);
    const [webContentHtmlPf, setWebContentHtmlPf] = React.useState("");
    const refCuota = React.useRef();
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    // --- Modal PRE-OFFER (paso previo)
    const [showPreOffer, setShowPreOffer] = React.useState(false);
    const [preOfferMsg, setPreOfferMsg] = React.useState("");

    // Modo oferta especial
    const [isSpecialOffer, setIsSpecialOffer] = React.useState(false);
    const [piePct, setPiePctState] = React.useState(20);
    const [specialOfferData, setSpecialOfferData] = React.useState(null); // { monto } del primer servicio
    const [specialSelectedCuotas, setSpecialSelectedCuotas] = React.useState(0);
    const [specialValorCuota, setSpecialValorCuota] = React.useState(0);

    const goToSecondStep = () => setNextStepPag(true);

    const clearAllForNewInput = React.useCallback(() => {
        // UI local
        setVisibleModal(false);
        setShowPreOffer(false);
        setTypeModal(false);
        setSucessAlert(false);
        setRedirectAlert(false);
        setButtonGenerarConvenio(false);
        setMsgModalAlert(false);

        // Paso 2 y variables locales
        setDues("");
        setSelectedFile({});
        setVerifReCaptcha(false);
        setIsClientIdCaptchaChecked(false);
        if (refCuota.current) refCuota.current.value = 0;
        setIsSpecialOffer(false);
        setSpecialSelectedCuotas(0);
        setSpecialValorCuota(0);

        // Respuestas del contexto (dejan de gatillar efectos)
        dispatch({ type: ACTIONS.SET_RESPONSE_PREOFFER, payload: null });
        dispatch({ type: ACTIONS.SET_RESPONSE_VC,        payload: null });
        dispatch({ type: ACTIONS.SET_RESPONSE_SDC,       payload: null });
        dispatch({ type: ACTIONS.SET_RESPONSE_SPE,       payload: null });
        dispatch({ type: ACTIONS.SET_RESPONSE_CPE,       payload: null });
        dispatch({ type: ACTIONS.SET_RESPONSE_CA,        payload: null });

        // Y cerramos el paso 2
        setNextStepPag(false);
    }, [dispatch]);

    // Helper: esconder/resetear paso 2
    const resetSecondStepUI = React.useCallback(() => {
        setNextStepPag(false);
        setButtonGenerarConvenio(false);
        setDues("");
        if (refCuota.current) refCuota.current.value = 0;
        // Especial
        setIsSpecialOffer(false);
        setSpecialSelectedCuotas(0);
        setSpecialValorCuota(0);
    }, []);

    // Reset completo cuando el usuario teclea en la vista pública
    const handlePublicTypingReset = React.useCallback(() => {
        // Oculta y limpia el paso 2 y el flujo especial
        resetSecondStepUI();

        // Limpia estados locales
        setIsClientIdCaptchaChecked(false);
        setSelectedFile({});
        setMsgModalAlert(false);
        setVisibleModal(false);
        setSucessAlert(false);
        setTypeModal(false);
        setRedirectAlert(false);
        setButtonGenerarConvenio(false);

        // Limpia buffers/auxiliares
        setResponseVc({});
        setResponseVcAux({});
        setResponseSc({});
        setSpecialOfferData(null);
        setPreOfferMsg("");

        // Opcional: limpiar detalle mostrado
        setDetailClientJson([]);
        // No toques inputSelected aquí; se está reescribiendo desde PubPa
        // setIdClient("");

        // Limpia respuestas en el contexto para evitar efectos tardíos con datos viejos
        dispatch({ type: ACTIONS.SET_RESPONSE_VC,  payload: null });
        dispatch({ type: ACTIONS.SET_RESPONSE_SDC, payload: null });
        dispatch({ type: ACTIONS.SET_RESPONSE_SPE, payload: null });
        dispatch({ type: ACTIONS.SET_RESPONSE_CPE, payload: null });
    }, [resetSecondStepUI, dispatch]);

    React.useEffect(() => {
        setLoading(true);
        dispatch({
            payload: true,
            type: ACTIONS.SET_LOAD_PAGE,
        });
        getPageLayoutType() ? setCanalFetch("ZOV") : setCanalFetch("URL");
    }, []);

    React.useEffect(() => {
        if (state.idList) {
            setLoading(false);
        }
    }, [state.idList]);

    React.useEffect(() => {
        if (nextStepPag) {
            setNextStepPag(false);
        }
    }, [inputSelected, inputSearch]);

    // VALIDAR (click) — NUEVO ORDEN: primero pre-oferta SIEMPRE
    function sendCli(numCli) {
        let auxNumCli;
        setDisabledBtn(false);
        getPageLayoutType() ? (auxNumCli = inputSelected) : (auxNumCli = numCli);
        setInputSelected(auxNumCli);

        clearAllForNewInput();

        if (auxNumCli) {
            setLoading(true);
            // 1) Validar Convenio Especial SIEMPRE primero
            const preBody = { numCli: auxNumCli, segmento: "07" };
            dispatch({ type: ACTIONS.SET_BODY_PREOFFER, payload: preBody });
        } else {
            properties.setGlobalAlert(
                getPageLayoutType()
                    ? "Debes ingresar o seleccionar un Nro. de Cliente"
                    : "Debes ingresar un Nro. de Cliente",
                "warning"
            );
        }
    }

    function generateAgreement() {
        if (!inputSelected) {
            return properties.setGlobalAlert("Debes ingresar o seleccionar un Nro. de cliente.", "warning");
        }

        // validar cuotas dependiendo del modo
        const selectedCuotas = isSpecialOffer ? Number(specialSelectedCuotas) : Number(dues);
        if (!selectedCuotas) {
            setInputFileValidate(true);
            return properties.setGlobalAlert("Complete todos los campos obligatorios.", "warning");
        }

        if ((!selectedFile?.identidad || !selectedFile?.dominioVigente) && responseVc?.showDocuments) {
            setInputFileValidate(true);
            return properties.setGlobalAlert("Complete todos los campos obligatorios.", "warning");
        }
        if (!getPageLayoutType() && !verifReCaptcha) {
            /*properties.setGlobalAlert(
                "Falta validar que no eres un Robot.",
                "warning"
            );*/
        }

        // Validación adicional para oferta especial
        if (isSpecialOffer && (!piePct || Number(piePct) <= 0)) {
            return properties.setGlobalAlert("Selecciona un porcentaje de Pie para continuar.", "warning");
        }

        setInputFileValidate(false);
        const msg = !responseVc?.showDocuments
            ? decode_utf8(properties?.msg_confirmacion_crear_convenio_1)
            : decode_utf8(properties?.msg_confirmacion_crear_convenio_2);

        setMsgModalAlert(msg);
        setTypeModal(true);
        setVisibleModal(true);
    }

    // RESPUESTA validaCliente (viejo)
    React.useEffect(() => {
        const objResponse = state.response_vc;
        setLoading(false);

        if (!objResponse) return;

        if (refCuota.current) refCuota.current.value = 0;

        if (objResponse.code >= 0) {
            if (objResponse.code === 1) {
                // Error -> ocultamos paso 2
                resetSecondStepUI();
                setVisibleModal(true);
                setTypeModal(false);
                setMsgModalAlert(
                    objResponse?.message || "El servicio no está disponible actualmente, intente más tarde."
                );
                setSucessAlert(false);
            } else {
                if (objResponse.message && getPageLayoutType()) {
                    setVisibleModal(true);
                    setTypeModal(false);
                    setMsgModalAlert(objResponse.message);
                }
                if (!objResponse?.cuotasNumber) {
                    // No cumple condiciones -> ocultamos paso 2
                    resetSecondStepUI();
                    setDisabledBtn(true);
                    setVisibleModal(true);
                    setTypeModal(false);
                    setMsgModalAlert(
                        "Lo sentimos, pero en este momento no podemos atender tu requerimiento. Lamentamos los inconvenientes y te pedimos que lo intentes en unos minutos más."
                    );
                } else {
                    setResponseVc(objResponse);
                    setResponseVcAux(objResponse);
                    // ✅ Flujo normal habilita el paso 2 aquí
                    setNextStepPag(true);
                }
            }
        } else {
            // Error técnico
            resetSecondStepUI();
            setVisibleModal(true);
            setTypeModal(false);
            setMsgModalAlert("El servicio no está disponible actualmente, intente más tarde.");
            setSucessAlert(false);
        }
    }, [state.response_vc, resetSecondStepUI]);

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        const ok = !!value;
        setVerifReCaptcha(ok);
        setIsClientIdCaptchaChecked(ok);
    }

    function sendCoutes(value) {
        if (Number(value)) {
            setDues(value);
            setLoading(true);
            dispatch({
                payload: {
                    numCli: inputSelected,
                    canal: canalFetch,
                    clave: responseVc.claveInteres,
                    pie: isSpecialOffer ? piePct : responseVc.pieConvenio,
                    docs: responseVc.docsList,
                    numCuota: value,
                },
                type: ACTIONS.SET_BODY_SDC,
            });
        } else {
            setResponseVc({ ...responseVc, montoCuota: responseVcAux.montoCuota, cuotaValue: "" });
            setDues("");
        }
    }

    React.useEffect(() => {
        const objResponse = state.response_sdc;
        setLoading(false);
        setResponseSc(objResponse);

        if (!objResponse) return;

        if (objResponse.code >= 0) {
            if (objResponse.code !== 0) {
                // Error simulación -> ocultamos paso 2
                resetSecondStepUI();
                setVisibleModal(true);
                setTypeModal(false);
                setMsgModalAlert(
                    objResponse?.message || "El servicio no está disponible actualmente, intente más tarde."
                );
                setSucessAlert(false);
            } else {
                if (objResponse.message) {
                    setVisibleModal(true);
                    setTypeModal(false);
                    setMsgModalAlert(objResponse.message);
                }
                setResponseVc({
                    ...responseVc,
                    montoCuota: objResponse.valorCuota,
                    cuotaValue: objResponse.numCuotas,
                });
            }
        } else {
            resetSecondStepUI();
            setSucessAlert(false);
            setVisibleModal(true);
            setTypeModal(false);
            setMsgModalAlert("En este momento la solicitud no se pudo procesar. Por favor intente nuevamente.");
        }
    }, [state.response_sdc, resetSecondStepUI, responseVc, responseVcAux]);

    // RESPUESTA pre-oferta — NUEVA ORQUESTACIÓN
    React.useEffect(() => {
        const pre = state.response_preoffer;
        if (!pre) return;

        const codigo = pre?.Return?.CodigoRetorno ?? pre?.Retorno?.CodigoRetorno;
        const monto = Number(pre?.Monto ?? pre?.monto ?? 0) || 0;

        // Guardamos para el paso 2 especial
        setPreOfferMsg(PREOFFER_TEXT);
        setSpecialOfferData({ monto });

        if (codigo === "S") {
            // Mostrar modal de pre-oferta. NO abrimos paso 2 aún.
            setIsSpecialOffer(false);
            setShowPreOffer(true);
        } else {
            // No califica para especial -> ahora sí llamamos al validar viejo
            dispatch({
                payload: { numCli: inputSelected, canal: canalFetch },
                type: ACTIONS.SET_BODY_VC,
            });
        }
        setLoading(false);
    }, [state.response_preoffer, canalFetch, inputSelected]);

    // ====== ESPECIAL: disparar SPE al cambiar cuotas y re-simular si cambia pie ======
    const handleSpecialCuotasChange = (cuotas) => {
        setSpecialSelectedCuotas(Number(cuotas) || 0);

        const montoBase = Number(specialOfferData?.monto || 0);
        if (!montoBase || !Number(cuotas)) return;

        const pieMonto = Math.round(montoBase * (Number(piePct) / 100));
        const montoEnviar = Math.max(montoBase - pieMonto, 0);

        setLoading(true);
        dispatch({
            type: ACTIONS.SET_BODY_SPE,
            payload: {
                monto: montoEnviar,
                cuotas: Number(cuotas),
            },
        });
    };

    const handleSpecialPieChange = (nuevoPiePct) => {
        setPiePctState(nuevoPiePct);
        if (specialSelectedCuotas > 0) {
            handleSpecialCuotasChange(specialSelectedCuotas);
        }
    };

    // Respuesta SimularConvenioPagoEspecial
    React.useEffect(() => {
        const spe = state.response_spe;
        if (!spe) return;
        setLoading(false);

        const vcuota = Number(spe?.ValorCuota ?? spe?.valorCuota ?? spe?.valor_cuota ?? 0) || 0;
        setSpecialValorCuota(vcuota);
    }, [state.response_spe]);

    function setErroUploadFile(msgErroUploadFile) {
        setVisibleModal(true);
        setTypeModal(false);
        setMsgModalAlert(msgErroUploadFile);
    }

    function createCont() {
        onClose();

        // Oferta especial: primero enviamos el notification (CPE)
        if (isSpecialOffer) {
            const selectedCuotas = Number(specialSelectedCuotas || dues);

            dispatch({
                type: ACTIONS.SET_BODY_CPE,
                payload: {
                    cuotas: selectedCuotas,
                    claveInteres: "L1",
                    pie: piePct, // porcentaje, sin '%'
                    cuentaContrato: inputSelected,
                },
            });

            setLoading(true);
            return; // Esperamos la respuesta en useEffect(response_cpe)
        }

        // ===== Flujo normal (igual que antes) =====
        dispatch({
            payload: {
                canal: canalFetch,
                claveInteres: responseVc?.claveInteres,
                codBarra: responseSc?.codBarra,
                numCli: inputSelected,
                docs: responseVc?.docsList,
                phrase1: decode_utf8(properties?.cupon_de_pago_1),
                phrase2: decode_utf8(properties?.cupon_de_pago_2),
                phrase3: decode_utf8(properties?.cupon_de_pago_3),
                montoCuota: responseSc?.valorCuota,
                montoDeuda: responseVc?.montoAdeudado,
                numCuotas: Number(dues),
                piePago: responseVc?.pieConvenio,
                tasaInteres: Number(responseVc?.tasaInteres.replace("%", "")),
                identidad: selectedFile?.identidad,
                poderNotarial: selectedFile?.poderNotarial,
                dominioVigente: selectedFile?.dominioVigente,
                showDocuments: responseVc?.showDocuments,
            },
            type: ACTIONS.SET_BODY_CA,
        });
        setLoading(true);
    }

    React.useEffect(() => {
        const objResponse = state.response_ca;
        if (!objResponse) return;

        setLoading(false);
        dispatch({ payload: null, type: ACTIONS.SET_RESPONSE_CA });
        setSucessAlert(false);

        if (objResponse?.status === 500 || objResponse?.status === 999) {
            setVisibleModal(true);
            setTypeModal(false);
            setMsgModalAlert(properties.text_fetch_error);
        } else if (objResponse?.status === -1) {
            setVisibleModal(true);
            setTypeModal(false);
            setMsgModalAlert(objResponse?.message);
        } else {
            setSucessAlert(true);
            setVisibleModal(true);
            setRedirectAlert(true);
            setButtonGenerarConvenio(true);
            setMsgModalAlert("Convenio generado exitosamente.");
        }
    }, [state.response_ca]);

    React.useEffect(() => {
        if (state?.webContentTextPa !== "ERROR") {
            setShowWebContentPa(true);
            setWebContentHtmlPa(state?.webContentTextPa);
        } else if (state?.webContentTextPa === "ERROR" || state?.webContentTextPa.status) {
            setVisibleModal(true);
            setTypeModal(false);
            setMsgModalAlert("Condiciones convenio de pago no está disponible, intente más tarde.");
            setShowWebContentPa(false);
            setWebContentHtmlPa("");
            setSucessAlert(false);
        }
    }, [state?.webContentTextPa]);

    React.useEffect(() => {
        if (state?.webContentTextPf !== "ERROR") {
            setShowWebContentPf(true);
            setWebContentHtmlPf(state?.webContentTextPf);
        } else if (state?.webContentTextPa === "ERROR" || state?.webContentTextPa.status) {
            setVisibleModal(true);
            setTypeModal(false);
            setMsgModalAlert("Condiciones convenio de pago no está disponible, intente más tarde.");
            setShowWebContentPf(false);
            setWebContentHtmlPf("");
            setSucessAlert(false);
        }
    }, [state?.webContentTextPf]);

    React.useEffect(() => {
        if (state.detailClient) {
            if (
                state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN ||
                state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0
            ) {
                if (state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
                    setDetailClientJson(state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM);
                } else {
                    setDetailClientJson([]);
                    properties.setGlobalAlert(
                        state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN ||
                        decode_utf8(properties.text_fetch_error),
                        "warning",
                        true,
                        "Advertencia"
                    );
                    setLoading(false);
                }
            } else {
                setLoading(false);
                setDetailClientJson([]);
                properties.setGlobalAlert(
                    decode_utf8(properties.text_fetch_error),
                    "warning",
                    true,
                    "Advertencia"
                );
            }
        }
    }, [state.detailClient]);

    React.useEffect(() => {
        const resp = state.response_cpe;
        if (!resp) return;

        setLoading(false);

        if (dispatch && ACTIONS?.SET_RESPONSE_CPE) {
            dispatch({ type: ACTIONS.SET_RESPONSE_CPE, payload: null });
        }

        const rawCodigo = resp?.codigo;
        const codeNum = Number(rawCodigo);
        const is2xx = Number.isFinite(codeNum) && codeNum >= 200 && codeNum < 300;

        const mensajeOk = resp?.mensaje || "Convenio generado exitosamente.";
        const mensajeErr =
            resp?.mensaje || "No pudimos registrar tu convenio especial en este momento. Intenta nuevamente.";

        if (is2xx) {
            setSucessAlert(true);
            setRedirectAlert(true);
            setButtonGenerarConvenio(true);
            setTypeModal(false);
            setMsgModalAlert(mensajeOk);
            setVisibleModal(true);
        } else {
            setSucessAlert(false);
            setTypeModal(false);
            setMsgModalAlert(mensajeErr);
            setVisibleModal(true);
            // En error también escondemos el paso 2
            resetSecondStepUI();
        }
    }, [state.response_cpe, resetSecondStepUI]);

    const objPropPriv = {
        data,
        setInputSearch,
        setInputSelected,
        inputSelected,
        inputSearch,
        sendClient: sendCli,
        disabledBtn: loading,
        showWebContentPa,
        webContentHtmlPa,
    };

    const objPropPub = {
        setInputSelected,
        setInputSearch,
        sendClient: sendCli,
        disabledBtn: loading,
        showWebContentPa,
        webContentHtmlPa,
        idClient,
        setIdClient,
        detailClientJson,
        state,
        isNextStep: nextStepPag,
        setNextStepPag,
        siteKey: properties.api_key_recaptcha,
        setGlobalAlert: properties.setGlobalAlert,
        isClientIdCaptchaChecked,
        setIsClientIdCaptchaChecked,
        setValueCoute: setDues,
        onPublicTypingReset: handlePublicTypingReset,
        onTypingClear: clearAllForNewInput,
    };

    const objPropSecondStep = {
        inputFileValidate,
        funcClick: sendCoutes,
        refCuota,
        valueCoute: dues,
        claveInteres: responseVc.claveInteres,
        cuotasNumber: responseVc.cuotasNumber,
        cuotaValue: responseVc.cuotaValue,
        message: responseVc.message,
        montoAdeudado: responseVc.montoAdeudado,
        clienteAfectado: responseVc.clienteAfectado,
        montoCuota: responseVc.montoCuota,
        numeroCliente: responseVc.numeroCliente,
        pieConvenio: responseVc.pieConvenio,
        showDocuments: responseVc.showDocuments,
        tasaInteres: responseVc.tasaInteres,
        setSelectedFile,
        selectedFile,
        setErroUploadFile,
        properties,
        showWebContentPf,
        webContentHtmlPf,
        titulo_superior_detalles_archivo: decode_utf8(
            properties?.titulo_superior_detalles_archivo
        ),

        // --- Especial ---
        isSpecialOffer,
        piePct: piePct,
        setPiePct: handleSpecialPieChange, // re-simula si ya hay cuotas
        specialOffer: specialOfferData, // { monto } del primer servicio
        speValorCuota: specialValorCuota, // ValorCuota del segundo servicio
        onSpecialCuotasChange: handleSpecialCuotasChange, // dispara SPE al cambiar cuotas
    };

    return (
        <>
            {getPageLayoutType() && (
                <HeaderSearch
                    data={data}
                    setSearch={setInputSearch}
                    setSelected={setInputSelected}
                    idClient={inputSelected}
                    inputSearch={inputSearch}
                />
            )}
            <CGE.Panel title="Convenio de Pago">
                {getPageLayoutType() ? <PrivPa props={objPropPriv} /> : <PubPa props={objPropPub} />}
                {nextStepPag && (
                    <>
                        <SecondStep props={objPropSecondStep} />
                        <div className="d-flex flex-column mx-auto align-items-center">
                            {!getPageLayoutType() && (
                                <div className="container-fluid container-fluid-max-md">
                                    <CGE.FieldRecaptcha
                                        onChange={onChangeReCaptcha}
                                        sitekey={properties.api_key_recaptcha}
                                    />
                                </div>
                            )}
                            {!buttonGenerarConvenio && (
                                <CGE.Button
                                    label="Generar Convenio"
                                    disabled={disabledBtn}
                                    onClick={() => {
                                        /*if (!getPageLayoutType() && !isClientIdCaptchaChecked) {
                                            return properties.setGlobalAlert(
                                                "Falta validar que no eres un Robot.",
                                                "warning"
                                            );
                                        }*/
                                        generateAgreement();
                                    }}
                                    type="primary"
                                />
                            )}
                        </div>
                    </>
                )}

                {visibleModal && (
                    <AlertModal
                        titleModal={sucessAlert ? "Confirmación" : "Advertencia"}
                        msgModal={msgModalAlert}
                        observer={observer}
                        onClose={redirectAlert ? handleCloseAndRedirect : onClose}
                        status={sucessAlert ? "success" : "warning"}
                        funcClick={createCont}
                        confirm={typeModal}
                        block={redirectAlert}
                    />
                )}

                {loading && <Loading />}
            </CGE.Panel>

            {showPreOffer && preOfferObserver && (
                <AlertModal
                    observer={preOfferObserver}
                    confirm
                    status="info"
                    titleModal="Convenio especial"
                    msgModal={preOfferMsg}
                    labelBtnConfirm="SI"
                    labelBtnCancel="NO"
                    onClose={() => {
                        // Usuario elige NO -> cerramos y vamos al validar viejo
                        preOfferOnClose();
                        setIsSpecialOffer(false);
                        // ahora sí validación vieja
                        dispatch({
                            payload: { numCli: inputSelected, canal: canalFetch },
                            type: ACTIONS.SET_BODY_VC,
                        });
                    }}
                    funcClick={() => {
                        // Usuario elige SI -> flujo especial (sin validar viejo)
                        preOfferOnClose();
                        setIsSpecialOffer(true);
                        goToSecondStep();
                    }}
                />
            )}
        </>
    );
};

const ControllerPaymentAgreementWithProvider = ({ properties }) => (
    <PaymentAgreementContextProvider>
        <ControllerPaymentAgreement properties={properties} />
    </PaymentAgreementContextProvider>
);
export default ControllerPaymentAgreementWithProvider;